import { Col, Row, Label, Input, Card } from "reactstrap";
import AppModal from "../../Common/AppModal";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import "../popupComponents.styles.scss";
import {
  createSupplier,
  createSupplierSuccess,
  getPaymentTermsList,
  getSupplierDetails,
  getSupplierList,
  updateSupplier,
  updateSupplierSuccess,
} from "../../../store/actions";
import Select from "../../Common/AppSelect";
import LoadingSpinner from "../../Common/Spinner";
// NEW: Companies House search
import { companiesHouseGovUKSearchCompanies } from "../../../store/companiesHouseGovUK/action";
import ClickOutside from "../../Common/ClickOutsideComponent";

export default function CreateSupplier({
  modalCreateSupplier,
  setModalCreateSupplier,
  toggleCreateSupplier,
  page,
  supplierDetailsAPI,
  supplierIsEdit,
  callBackFunction = () => {},
}) {
  const dispatch = useDispatch();
  const SupplierDetailsInitialState = {
    SupplierBusinessType_Id: "",
    // Business
    BusinessName: "",
    RegNo: "", // NEW: company registration number
    // Person
    PersonTitle: "",
    PersonFirstName: "",
    PersonLastName: "",
    // Address
    AddressLine1: "",
    AddressLine2: "",
    AddressLine3: "",
    AddressLine4: "",
    AddressCity: "",
    AddressCounty: "",
    AddressPostCode: "",
    AddressCountry: "",
    // Other
    BalanceOpening: "",
    Notes: "",
    PaymentTerm_Id: "",
  };
  const [supplierDetails, setSupplierDetails] = useState(
    SupplierDetailsInitialState
  );

  // Payment terms
  const { paymentTermsList } = useSelector((state) => ({
    paymentTermsList: state.PaymentTerm.paymentTermsList?.paymentterm_list,
  }));

  // Companies House (CH) search state
  const [searchQuery, setSearchQuery] = useState("");
  const [showResults, setShowResults] = useState(false);
  const [selectCompanyFromSearch, setSelectCompanyFromSearch] = useState(null);
  const { companies: chCompanies, chLoading } = useSelector((state) => ({
    companies: state.CompaniesHouseGovUK.companies,
    chLoading: state.CompaniesHouseGovUK.loading,
  }));

  useEffect(() => {
    dispatch(getPaymentTermsList());
    if (!supplierIsEdit) {
      setSupplierDetails(SupplierDetailsInitialState);
    }
  }, []);

  // if is edit true then assign values from supplierDetailsAPI
  useEffect(() => {
    if (!supplierIsEdit) return;
    if (isEmpty(supplierDetailsAPI)) return;
    setSupplierDetails({
      Id: supplierDetailsAPI?.Id,
      SupplierBusinessType_Id: supplierDetailsAPI?.SupplierBusinessType_Id,
      BusinessName: supplierDetailsAPI?.BusinessName,
      RegNo: supplierDetailsAPI?.RegNo || "",
      PersonTitle: supplierDetailsAPI?.PersonTitle,
      PersonFirstName: supplierDetailsAPI?.PersonFirstName,
      PersonLastName: supplierDetailsAPI?.PersonLastName,
      AddressLine1: supplierDetailsAPI?.AddressLine1,
      AddressLine2: supplierDetailsAPI?.AddressLine2,
      AddressLine3: supplierDetailsAPI?.AddressLine3,
      AddressLine4: supplierDetailsAPI?.AddressLine4,
      AddressCity: supplierDetailsAPI?.AddressCity,
      AddressCounty: supplierDetailsAPI?.AddressCounty,
      AddressPostCode: supplierDetailsAPI?.AddressPostCode,
      AddressCountry: supplierDetailsAPI?.AddressCountry,
      BalanceOpening: supplierDetailsAPI?.BalanceOpening,
      Notes: supplierDetailsAPI?.Notes,
      PaymentTerm_Id: supplierDetailsAPI?.PaymentTerm_Id,
    });
  }, [supplierDetailsAPI, supplierIsEdit]);

  // Debounced CH search (only for Business)
  useEffect(() => {
    if (supplierDetails.SupplierBusinessType_Id !== "1") return;
    const delay = setTimeout(() => {
      if (!isEmpty(searchQuery)) {
        dispatch(companiesHouseGovUKSearchCompanies({ id: searchQuery }));
      }
    }, 500);
    return () => clearTimeout(delay);
  }, [searchQuery, supplierDetails.SupplierBusinessType_Id]);

  // Access Redux State
  const { validationResponse, supplierCreatedSuccessLoading } = useSelector(
    (state) => ({
      validationResponse: state.Supplier.supplierCreatedSuccess,
      supplierCreatedSuccessLoading:
        state.Supplier.supplierCreatedSuccessLoading,
    })
  );

  // Handle Create/Update Supplier
  const handleCreateUpdateSupplier = (createUpdate) => {
    if (supplierDetails.SupplierBusinessType_Id === "1") {
      if (isEmpty(supplierDetails.BusinessName)) {
        toast.error("Please enter business name");
        return;
      }
    }
    if (supplierDetails.SupplierBusinessType_Id === "2") {
      if (isEmpty(supplierDetails.PersonTitle)) {
        toast.error("Please enter title");
        return;
      }
      if (isEmpty(supplierDetails.PersonFirstName)) {
        toast.error("Please enter first name");
        return;
      }
      if (isEmpty(supplierDetails.PersonLastName)) {
        toast.error("Please enter last name");
        return;
      }
      // First Line
      if (isEmpty(supplierDetails.AddressLine1)) {
        toast.error("Please enter first line");
        return;
      }
      // City
      if (isEmpty(supplierDetails.AddressCity)) {
        toast.error("Please enter city");
        return;
      }
      // postCode
      if (isEmpty(supplierDetails.AddressPostCode)) {
        toast.error("Please enter post code");
        return;
      }
    }

    const sendData = [supplierDetails];
    if (createUpdate === "create") {
      dispatch(createSupplier(sendData));
    }
    if (createUpdate === "update") {
      dispatch(updateSupplier(sendData));
    }
  };

  // create success
  useEffect(() => {
    if (isEmpty(validationResponse)) return;
    if (validationResponse) {
      if (validationResponse.status === 200) {
        toast.success(validationResponse.message);
        setModalCreateSupplier(false);
        dispatch(getSupplierList());
        if (validationResponse?.Supplier_Id) {
          callBackFunction(validationResponse.Supplier_Id);
        }
      } else {
        toast.error(validationResponse.message);
      }
    }
    dispatch(createSupplierSuccess([]));
  }, [validationResponse]);

  const { supplierUpdatedSuccessAPI, supplierUpdatedSuccessLoading } =
    useSelector((state) => ({
      supplierUpdatedSuccessAPI: state.Supplier.supplierUpdatedSuccess,
      supplierUpdatedSuccessLoading:
        state.Supplier.supplierUpdatedSuccessLoading,
    }));

  //update success
  useEffect(() => {
    if (isEmpty(supplierUpdatedSuccessAPI)) return;
    if (supplierUpdatedSuccessAPI.status === 200) {
      toast.success(supplierUpdatedSuccessAPI.message);
      setModalCreateSupplier(false);
      dispatch(getSupplierList());
      dispatch(getSupplierDetails({ id: supplierDetailsAPI?.Id }));
    } else {
      toast.error(supplierUpdatedSuccessAPI.message);
    }
    dispatch(updateSupplierSuccess([]));
  }, [supplierUpdatedSuccessAPI]);

  // Helpers
  const clearCHState = () => {
    setSearchQuery("");
    setShowResults(false);
    setSelectCompanyFromSearch(null);
  };

  return (
    <>
      <AppModal
        open={modalCreateSupplier}
        onClose={toggleCreateSupplier}
        title={supplierIsEdit ? "Edit Supplier" : "Create Supplier"}
        icon={<LocalShippingOutlinedIcon />}
        headerAccent="indigo"
        size="sm"
        hideFooter
      >
          <Row className=" ">
            <Col lg={12}>
              <div>
                <div className={" "}>
                  <div htmlFor="company_name-field" className="form-label">
                    Please select the type of business
                  </div>
                  <div>
                    <input
                      type="radio"
                      className="btn-check"
                      name="transaction_type"
                      id="option2"
                      value={"1"}
                      checked={supplierDetails.SupplierBusinessType_Id === "1"}
                      autoComplete="off"
                      onChange={() => {
                        clearCHState();
                        setSupplierDetails({
                          ...supplierDetails,
                          SupplierBusinessType_Id: "1",
                        });
                      }}
                    />
                    <label
                      className={
                        supplierDetails.SupplierBusinessType_Id === "1"
                          ? "btn btn-primary"
                          : "btn btn-soft-primary"
                      }
                      htmlFor="option2"
                    >
                      Business
                    </label>{" "}
                    <input
                      type="radio"
                      className="btn-check "
                      name="transaction_type"
                      id="option1"
                      autoComplete="off"
                      checked={supplierDetails.SupplierBusinessType_Id === "2"}
                      value={"2"}
                      onChange={() => {
                        clearCHState();
                        setSupplierDetails({
                          ...supplierDetails,
                          SupplierBusinessType_Id: "2",
                        });
                      }}
                    />
                    <label
                      className={
                        supplierDetails.SupplierBusinessType_Id === "2"
                          ? "btn btn-primary"
                          : "btn btn-soft-primary"
                      }
                      htmlFor="option1"
                    >
                      Person
                    </label>
                  </div>
                </div>
              </div>
            </Col>

            {supplierDetails.SupplierBusinessType_Id && (
              <>
                {/* BUSINESS: Companies House lookup + fields */}
                {supplierDetails.SupplierBusinessType_Id === "1" && (
                  <Col lg={12} className={"p-2"}>
                    <ClickOutside onClick={() => setShowResults(false)}>
                      <div className={"w-100"}>
                        <Label>
                          Search Business Name{" "}
                          <span className="text-danger">*</span>
                        </Label>
                        <Input
                          type="search"
                          className={"form-control"}
                          value={supplierDetails.BusinessName}
                          placeholder={"Type to search Companies House…"}
                          onFocus={() => setShowResults(true)}
                          onBlur={() =>
                            setTimeout(() => setShowResults(false), 300)
                          }
                          onChange={(e) => {
                            const v = e.target.value;
                            setSupplierDetails({
                              ...supplierDetails,
                              BusinessName: v,
                            });
                            if (!v) {
                              clearCHState();
                            } else {
                              setSearchQuery(v);
                              setShowResults(true);
                            }
                          }}
                        />
                      </div>

                      {searchQuery.length > 0 && showResults && (
                        <div className="mt-1 small text-muted">
                          Companies House search results
                        </div>
                      )}

                      {showResults && (
                        <div
                          className={"pb-2 company-house-response-list mt-1"}
                          style={{
                            maxHeight: 280,
                            overflowY: "auto",
                            border: "1px solid #eee",
                            borderRadius: 6,
                          }}
                        >
                          {chLoading && (
                            <div className="p-2 small text-muted">
                              Searching…
                            </div>
                          )}
                          {chCompanies?.items?.map((item, index) => {
                            return (
                              <Card
                                key={index}
                                className={
                                  "d-flex flex-row justify-content-between align-items-center p-2 m-1"
                                }
                              >
                                <div className={"d-flex flex-column flex-wrap"}>
                                  <div className="fw-semibold">
                                    {item.title}
                                  </div>
                                  {item.description && (
                                    <div className="text-muted small">
                                      {item.description}
                                    </div>
                                  )}
                                  <div className="small">
                                    {item?.address?.address_line_1 ?? ""}{" "}
                                    {item?.address?.address_line_2 ?? ""}{" "}
                                    {item?.address?.locality ?? ""}{" "}
                                    {item?.address?.postal_code ?? ""}
                                  </div>
                                </div>
                                <div>
                                  <button
                                    type="button"
                                    className={"btn btn-sm btn-primary"}
                                    onClick={() => {
                                      setSupplierDetails({
                                        ...supplierDetails,
                                        BusinessName: item?.title ?? "",
                                        RegNo: item?.company_number ?? "",
                                        AddressLine1: `${
                                          item?.address?.premises ?? ""
                                        } ${
                                          item?.address?.address_line_1 ?? ""
                                        }`.trim(),
                                        AddressLine2:
                                          item?.address?.address_line_2 ?? "",
                                        AddressCity:
                                          item?.address?.locality ?? "",
                                        AddressCounty:
                                          item?.address?.region ??
                                          supplierDetails.AddressCounty ??
                                          "",
                                        AddressPostCode:
                                          item?.address?.postal_code ?? "",
                                        AddressCountry:
                                          item?.address?.country ?? "",
                                      });
                                      setSearchQuery("");
                                      setShowResults(false);
                                      setSelectCompanyFromSearch(item);
                                    }}
                                  >
                                    Select
                                  </button>
                                </div>
                              </Card>
                            );
                          })}
                        </div>
                      )}

                      {/* Manual override fields (BusinessName & RegNo) */}
                      <div className={"w-100 mt-2"}>
                        <Label title={"Required"}>
                          Business Name <span className={"text-danger"}>*</span>
                        </Label>
                        <Input
                          type="text"
                          className={"form-control"}
                          value={supplierDetails.BusinessName}
                          onChange={(e) =>
                            setSupplierDetails({
                              ...supplierDetails,
                              BusinessName: e.target.value,
                            })
                          }
                        />
                      </div>

                      <div className={"w-100 mt-2"}>
                        <Label>Registration Number</Label>
                        <Input
                          type="text"
                          className={"form-control"}
                          value={supplierDetails.RegNo}
                          onChange={(e) =>
                            setSupplierDetails({
                              ...supplierDetails,
                              RegNo: e.target.value,
                            })
                          }
                        />
                      </div>
                    </ClickOutside>
                  </Col>
                )}

                {/* PERSON fields (unchanged) */}
                {supplierDetails.SupplierBusinessType_Id === "2" && (
                  <>
                    <Col lg={4} className={"p-2"}>
                      <div>
                        <Input
                          name="PersonTitle"
                          id="PersonTitle"
                          className="form-control"
                          placeholder={"Your Title"}
                          type="text"
                          onChange={(e) => {
                            setSupplierDetails({
                              ...supplierDetails,
                              PersonTitle: e.target.value,
                            });
                          }}
                          value={supplierDetails.PersonTitle}
                        />
                      </div>
                    </Col>

                    <Col lg={4} className={"p-2"}>
                      <div>
                        <Input
                          name="PersonFirstName"
                          id="PersonFirstName"
                          className="form-control"
                          placeholder={"First Name"}
                          type="text"
                          onChange={(e) => {
                            setSupplierDetails({
                              ...supplierDetails,
                              PersonFirstName: e.target.value,
                            });
                          }}
                          value={supplierDetails.PersonFirstName}
                        />
                      </div>
                    </Col>
                    <Col lg={4} className={"p-2"}>
                      <div>
                        <Input
                          name="PersonLastName"
                          id="PersonLastName"
                          className="form-control"
                          placeholder={"Last Name"}
                          type="text"
                          onChange={(e) => {
                            setSupplierDetails({
                              ...supplierDetails,
                              PersonLastName: e.target.value,
                            });
                          }}
                          value={supplierDetails.PersonLastName}
                        />
                      </div>
                    </Col>
                  </>
                )}

                {/* Address (shared) */}
                <Col lg={6} className={"p-2"}>
                  <div>
                    <Input
                      name="AddressLine1"
                      id="AddressLine1"
                      className="form-control"
                      placeholder={"Enter First Line of Address"}
                      type="text"
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          AddressLine1: e.target.value,
                        });
                      }}
                      value={supplierDetails.AddressLine1}
                    />
                  </div>
                </Col>
                <Col lg={6} className={"p-2"}>
                  <div>
                    <Input
                      name="AddressLine2"
                      id="AddressLine2"
                      className="form-control"
                      placeholder={"Enter Second Line of Address"}
                      type="text"
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          AddressLine2: e.target.value,
                        });
                      }}
                      value={supplierDetails.AddressLine2}
                    />
                  </div>
                </Col>
                <Col lg={6} className={"p-2"}>
                  <div>
                    <Input
                      name="AddressLine3"
                      id="AddressLine3"
                      className="form-control"
                      placeholder={"Enter Third Line of Address"}
                      type="text"
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          AddressLine3: e.target.value,
                        });
                      }}
                      value={supplierDetails.AddressLine3}
                    />
                  </div>
                </Col>
                <Col lg={6} className={"p-2"}>
                  <div>
                    <Input
                      name="AddressLine4"
                      id="AddressLine4"
                      className="form-control"
                      placeholder={"Enter Fourth Line of Address"}
                      type="text"
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          AddressLine4: e.target.value,
                        });
                      }}
                      value={supplierDetails.AddressLine4}
                    />
                  </div>
                </Col>
                <Col lg={6} className={"p-2"}>
                  <div>
                    <Input
                      name="AddressCity"
                      id="AddressCity"
                      className="form-control"
                      placeholder={"Enter City"}
                      type="text"
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          AddressCity: e.target.value,
                        });
                      }}
                      value={supplierDetails.AddressCity}
                    />
                  </div>
                </Col>

                <Col lg={6} className={"p-2"}>
                  <div>
                    <Input
                      name="AddressCounty"
                      id="AddressCounty"
                      className="form-control"
                      placeholder={"Enter County"}
                      type="text"
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          AddressCounty: e.target.value,
                        });
                      }}
                      value={supplierDetails.AddressCounty}
                    />
                  </div>
                </Col>
                <Col lg={6} className={"p-2"}>
                  <div>
                    <Input
                      name="AddressPostCode"
                      id="AddressPostCode"
                      className="form-control"
                      placeholder={"Enter PostCode"}
                      type="text"
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          AddressPostCode: e.target.value,
                        });
                      }}
                      value={supplierDetails.AddressPostCode}
                    />
                  </div>
                </Col>
                <Col lg={6} className={"p-2"}>
                  <div>
                    <Input
                      name="AddressCountry"
                      id="AddressCountry"
                      className="form-control"
                      placeholder={"Enter Country"}
                      type="text"
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          AddressCountry: e.target.value,
                        });
                      }}
                      value={supplierDetails.AddressCountry}
                    />
                  </div>
                </Col>
                <hr className={"mt-4"} />
                <Col lg={12}>
                  <div>
                    <Label>Select Payment Term</Label>
                    <Select
                      isClearable={true}
                      className="mb-0 job-select2"
                      placeholder={"Select Payment Term"}
                      value={
                        supplierDetails?.PaymentTerm_Id
                          ? {
                              label: paymentTermsList?.find(
                                (item) =>
                                  item.Id === supplierDetails?.PaymentTerm_Id
                              )?.Name,
                              value: supplierDetails?.PaymentTerm_Id,
                              id: supplierDetails?.PaymentTerm_Id,
                            }
                          : []
                      }
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          PaymentTerm_Id: e?.value,
                        });
                      }}
                      options={
                        !isEmpty(paymentTermsList)
                          ? paymentTermsList?.map((item) => ({
                              label: item?.Name,
                              value: item?.Id,
                              id: item?.Id,
                            }))
                          : []
                      }
                      id="country-select"
                    ></Select>
                  </div>
                </Col>
                <Col lg={12} className={"mt-3"}>
                  <div>
                    <Input
                      name="openingBalance"
                      id="openingBalance"
                      className="form-control"
                      placeholder={"Opening Balance"}
                      type="text"
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          BalanceOpening: e.target.value,
                        });
                      }}
                      value={supplierDetails.BalanceOpening}
                    />
                  </div>
                </Col>
                <Col lg={12} className={"mt-3"}>
                  <div>
                    <textarea
                      name="openingBalance"
                      id="openingBalance"
                      className="form-control"
                      placeholder={"Notes..."}
                      onChange={(e) => {
                        setSupplierDetails({
                          ...supplierDetails,
                          Notes: e.target.value,
                        });
                      }}
                      value={supplierDetails.Notes}
                    />
                  </div>
                </Col>

                <Col lg={12} className={"p-2"}>
                  <div className={"d-flex justify-content-center pt-2"}>
                    {supplierUpdatedSuccessLoading ||
                    supplierCreatedSuccessLoading ? (
                      <LoadingSpinner size={"small"} row={true} />
                    ) : (
                      <div className={"d-flex justify-content-center pt-2"}>
                        {!supplierIsEdit ? (
                          <button
                            onClick={() => {
                              handleCreateUpdateSupplier("create");
                            }}
                            className={"btn btn-success"}
                          >
                            Create Supplier
                          </button>
                        ) : (
                          <button
                            onClick={() => {
                              handleCreateUpdateSupplier("update");
                            }}
                            className={"btn btn-success"}
                          >
                            Update Supplier
                          </button>
                        )}
                      </div>
                    )}
                  </div>
                </Col>
              </>
            )}
          </Row>
      </AppModal>
    </>
  );
}
